/**
 * Whether this window is the Labs preview running INSIDE a guide page's frame, where the consent
 * dialog must not be drawn a second time.
 *
 * The guide page (www.extern.com) already shows the Cookiebot banner, and Cookiebot's cookie is
 * scoped to `.extern.com`, so it is ONE decision shared by both windows. Only a reader who has not
 * answered yet sees a dialog at all, and that reader has the banner open on the page around the
 * frame. Inside a 560px box the second copy is not a bar at the bottom: it is a panel across the
 * middle of the lab's first card, which is the first thing a Labs reader saw (Sep 19).
 *
 * 🔴 THIS HIDES A DUPLICATE PROMPT. IT DOES NOT GRANT, ASSUME OR SKIP CONSENT. Cookiebot still
 * loads, still reads the shared cookie, and every vendor still reads its answer from
 * `@extern/consent`. A reader who has not answered stays exactly as unanswered as before, and is
 * still asked, by the banner on the page they are actually on.
 *
 * 🔴 ALL THREE CONDITIONS, NOT JUST THE PARAMETER. `?via=embed` is forgeable, so on its own it would
 * let anyone open a top-level `/try` page with no consent prompt anywhere on screen. The window
 * must really be framed, and `frame-ancestors` only lets extern.com's own pages frame this route,
 * all of which carry the banner. Anywhere else the dialog shows as it always has.
 */
export const CONSENT_DIALOG_HIDDEN_CSS =
  '#CybotCookiebotDialog,#CybotCookiebotDialogBodyUnderlay,#CookiebotWidget{display:none!important}';

const EMBED_ROUTE_PREFIX = '/try/';
const EMBED_PARAM = 'via';
const EMBED_VALUE = 'embed';

export function isConsentDialogSuppressed(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  let framed = false;
  try {
    framed = window.self !== window.top;
  } catch {
    // Reading `window.top` can throw across origins. Only a framed window can throw here.
    framed = true;
  }
  return (
    framed &&
    window.location.pathname.startsWith(EMBED_ROUTE_PREFIX) &&
    new URLSearchParams(window.location.search).get(EMBED_PARAM) === EMBED_VALUE
  );
}
